import Vue from 'vue'
import { Icon } from 'ant-design-vue'

Vue.use(Icon)

const L8Icon = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_1168757_t6f5e5fzfx.js', // 在 iconfont.cn 上生成
  extraCommonProps: {
    className: 'l8-icon'
  }
})
Vue.component('l8-icon', L8Icon)
